export default "__VITE_ASSET__CPVWniNl__"